export default (container, preventDefaultClassName) => {

    const handleMouseDown = (e) => {
        const containerRect = container?.getBoundingClientRect();

        const startPos = {
            x: e.clientX - containerRect.left,
            y: e.clientY - containerRect.top,
        };

        const handleMouseMove = (e) => {
            container.style.left = e.clientX - startPos.x + 'px';
            container.style.top = e.clientY - startPos.y + 'px';
        };

        const handleMouseUp = () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleTouchStart = (e) => {
        if (e.target.className === preventDefaultClassName || !e.target.className) {
            e.preventDefault();
        }
        const containerRect = container?.getBoundingClientRect();
        const touch = e.touches[0];

        const startPos = {
            x: touch.clientX - containerRect.left,
            y: touch.clientY - containerRect.top,
        };

        const handleTouchMove = (e) => {
            const touch = e.touches[0];
            
            container.style.left = touch.clientX - startPos.x + 'px';
            container.style.top = touch.clientY - startPos.y + 'px';
        };

        const handleTouchEnd = () => {
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchEnd);
        };

        document.addEventListener('touchmove', handleTouchMove);
        document.addEventListener('touchend', handleTouchEnd);
    };

    if (container) {
        container.addEventListener('mousedown', handleMouseDown);
        container.addEventListener('touchstart', handleTouchStart);
    }

}
